import React from 'react';
import { useContext } from 'react';
import quizInstanceStatusContext from '../context/quizInstanceStatusContext';
import Status from '../enums/QuizInstanceStatus';
import QuizWaitingRoom from './QuizWaitingRoom';
import Quiz from './Quiz';
import QuizParticipantLiveResults from './QuizParticipantLiveResults';

export default function QuizWrapper() {

  const quizStatus = useContext(quizInstanceStatusContext);

  if (quizStatus.status === Status.LiveResults)
  {
    return <QuizParticipantLiveResults />
  }

  if (!quizStatus.quizInfo.started)
  {
    return <QuizWaitingRoom />
  }

  return <Quiz />;
}